module.exports = __webpack_public_path__ + "static/fonction5-af5f314cc0f963f9015cb6165c5226a0.jpg";